import { CustomStepDefinition, LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IntensityBucketEnum } from 'src/portal/search-api/models/intensity-bucket-enum';

@Component({
  selector: 'search-filter-slider-intensity',
  templateUrl: './search-filter-slider-intensity.component.html',
  styleUrls: ['./search-filter-slider-intensity.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchFilterSliderIntensityComponent implements OnChanges {

  @Input() selectedIntensity: IntensityBucketEnum | undefined;
  @Input() disabled: boolean = false;
  @Output() onChangeValue = new EventEmitter<IntensityBucketEnum[]>();

  private readonly intensitySteps: Array<{ value: IntensityBucketEnum | undefined; label: string }> = [
    { value: undefined, label: 'Any' },
    { value: IntensityBucketEnum.LOW, label: 'Low' },
    { value: IntensityBucketEnum.MEDIUM, label: 'Medium' },
    { value: IntensityBucketEnum.HIGH, label: 'High' },
  ];
  // Ordered from highest to lowest to build inclusive selections.
  private readonly cascadingOrder: IntensityBucketEnum[] = [
    IntensityBucketEnum.HIGH,
    IntensityBucketEnum.MEDIUM,
    IntensityBucketEnum.LOW,
  ];

  sliderValue: number = 0;
  sliderOptions: Options = this.buildSliderOptions(this.disabled);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      this.sliderOptions = this.buildSliderOptions(this.disabled);
    }
    if (changes.selectedIntensity) {
      this.sliderValue = this.intensityToIndex(this.selectedIntensity);
    }
  }

  private intensityToIndex(intensity: IntensityBucketEnum | undefined): number {
    const index = this.intensitySteps.findIndex((step) => step.value === intensity);
    return index >= 0 ? index : 0;
  }

  public onIntensityChange(): void {
    const step = this.intensitySteps[this.sliderValue];
    this.onChangeValue.emit(this.buildCascadeSelection(step?.value));
  }

  private buildSliderOptions(disabled: boolean): Options {
    return {
      floor: 0,
      ceil: this.intensitySteps.length - 1,
      showTicks: true,
      showTicksValues: true,
      animate: true,
      rightToLeft: true,
      disabled,
      stepsArray: this.intensitySteps.map((_, index): CustomStepDefinition => ({ value: index })),
      translate: (value: number, label: LabelType): string => {
        const step = this.intensitySteps[value];
        return step?.label ?? '';
      },
    };
  }

  private buildCascadeSelection(selectedValue: IntensityBucketEnum | undefined): IntensityBucketEnum[] {
    if (!selectedValue) {
      return [];
    }

    const index = this.cascadingOrder.indexOf(selectedValue);
    if (index === -1) {
      return [];
    }

    return this.cascadingOrder.slice(0, index + 1);
  }
}
